import { Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './styles';

interface ISectionHeader {
    title: string
}

const SectionHeader: React.FC<ISectionHeader> = ({ title }) => {
  const classes = useStyles();
  return (
    <div className={classes.rootSectionTitle}>
      <Typography variant="h3" className={classes.sectionTitle} style={{ whiteSpace: 'pre-line' }}>
        {title}
      </Typography>
    </div>
  );
};

export default SectionHeader;
